const INITIAL_STATE = {
  message: null,
  dialog: null,
};

export default function alertsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'PUSH_ALERT':
      return {
        ...state,
        message: action.message,
      };
    case 'PUSH_DIALOG':
      return {
        ...state,
        dialog: {
          ...action.dialog,
          title: action.dialog.title || '',
        },
      };
    default:
      return state;
  }
}
